import { MessageDesignTokens } from '@primeuix/themes/types/message';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tDeep, tFlat, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/message/index.ts
const msg = tDeep(componentCommon.message);
const msgCs = componentColorScheme.message;

export const MessageTelekomDT: MessageDesignTokens = {
  root: {
    borderRadius: '0',
    borderWidth: msg.border.width,
  },
  content: {
    padding: `${msg.content.padding.y} ${msg.content.padding.x}`,
    gap: msg.content.gap,
    sm: { padding: `${msg.content.sm.padding.y} ${msg.content.sm.padding.x}` },
    lg: { padding: `${msg.content.lg.padding.y} ${msg.content.lg.padding.x}` },
  },
  text: {
    fontSize: msg.text.font.size,
    fontWeight: tNum(componentCommon.message.text.font.weight),
    sm: { fontSize: msg.text.sm.font.size },
    lg: { fontSize: msg.text.lg.font.size },
  },
  icon: msg.icon,
  closeButton: {
    width: msg.close.button.width,
    height: msg.close.button.height,
    borderRadius: msg.close.button.border.radius,
    focusRing: {
      width: msg.close.button.focus.ring.width,
      offset: msg.close.button.focus.ring.offset,
    },
  },
  closeIcon: {
    size: msg.close.icon.size,
    sm: { size: msg.close.icon.sm.size },
    lg: { size: msg.close.icon.lg.size },
  },
  outlined: {
    root: { borderWidth: msg.outlined.border.width },
  },
  simple: {
    content: { padding: msg.simple.content.padding },
  },
  colorScheme: {
    light: {
      info: tFlat(msgCs.info),
      success: tFlat(msgCs.success),
      warn: tFlat(msgCs.warn),
      error: tFlat(msgCs.error),
    },
  },
};
